var _linearGradient, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 47,
    viewBox: "0 0 48 47",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 0.503906,
    x2: 47.4063,
    y1: 23.3681,
    y2: 23.3681
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00adbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002f87"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m38.5933-.00878906c2.1208 0 4.1844.72829706 5.775 2.12776906h-.0143c2.0349 1.79932 3.0523 4.01278 3.0523 6.64036v29.21756c0 2.8561-1.1894 5.2123-3.5825 7.0831-1.476 1.1567-3.3389 1.685-5.2019 1.685h-29.31932c-2.63674 0-4.85789-1.0139-6.66348-3.0417-1.40435-1.5851-2.135194-3.6415-2.135194-5.755v-29.18896c0-2.62758 1.017444-4.84104 3.052314-6.64036 1.59064-1.399472 3.65417-2.12776906 5.77503-2.12776906zm-1.4902 13.92408906 2.4934-2.3706v-.0285-.5141h-8.641l-6.162 15.28-7.0074-15.28h-9.05662v.5141l2.90902 3.4987c.2866.257.4442.6283.4012 1.0139v13.7377c.1003.4998-.0573 1.0139-.4155 1.3851l-3.28164 3.97v.5141h9.31454v-.5141l-3.2816-3.97c-.3582-.357-.5302-.8568-.4585-1.3566v-11.8955l8.1681 17.7362h.9458l7.0218-17.7362v14.1233c0 .3855 0 .4569-.2436.6997l-2.5221 2.4419v.5141h12.2522v-.5141l-2.4361-2.3848c-.215-.1571-.3296-.4141-.2866-.6854v-17.4792c-.043-.2713.0716-.5426.2866-.6997z",
    fill: "url(#a)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.2a9dd9db281bed90a56cd386c4b35a84.svg";
export { ForwardRef as ReactComponent };